var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.422 5.063v3.254l2.765-1.382a.422.422 0 1 1 .376.755L9.188 9.378A.422.422 0 0 1 8.578 9V5.062a.422.422 0 0 1 .844 0ZM9 15.328A6.328 6.328 0 1 1 15.328 9a.422.422 0 0 0 .844 0A7.172 7.172 0 1 0 9 16.172a.422.422 0 0 0 0-.844Zm7.158.314a.422.422 0 0 1-.816.216c-.215-.811-.972-1.374-1.842-1.374-.87 0-1.627.563-1.842 1.374a.422.422 0 0 1-.816-.216 2.678 2.678 0 0 1 1.302-1.65 2.11 2.11 0 1 1 2.712 0 2.677 2.677 0 0 1 1.302 1.65Zm-3.924-3.267a1.265 1.265 0 1 0 2.53 0 1.265 1.265 0 0 0-2.53 0Z",
    fill: "#595959"
  })));
};
export default SvgTime;